export const getTranslatableSlug = (story, lang) => story.translated_slugs?.find(s => s.lang === lang);
